module.exports = __webpack_public_path__ + "img/O.56fdfc89.png";